import { useFontMixer } from "./FontMixerContext";
import { useMemo } from "react";
import { useSvgViewBoxZoom } from "../../hooks/useSvgViewBoxZoom";

export function FontMixerViewer() {
    const {
        viewBoxAttr,
        charLayout,
        canExport,
        handleDownload,
        selectedFonts,
    } = useFontMixer();

    const base = useMemo(() => {
        const [x, y, w, h] = viewBoxAttr.split(" ").map(Number);
        return { x, y, w, h };
    }, [viewBoxAttr]);

    const {
        svgRef,
        viewBoxAttr: viewBox,
        panHandlers,
        zoomPercent,
        zoomIn,
        zoomOut,
        resetView,
    } = useSvgViewBoxZoom({ base });

    const hasNoFonts = selectedFonts.length === 0;

    return (
        <div className="font-mixer-viewer">
            <div className="path-tool-preview">
                <div className="svg-zoom-controls">
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomOut}
                        title="Zoom out"
                    >
                        −
                    </button>
                    <span className="zoom-level">{zoomPercent}%</span>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomIn}
                        title="Zoom in"
                    >
                        +
                    </button>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={resetView}
                        title="Reset zoom"
                    >
                        ⌂
                    </button>
                </div>
                <div className="svg-scroll-wrapper">
                    {hasNoFonts || charLayout.length === 0 ? (
                        <div className="svg-placeholder">
                            <p>
                                {hasNoFonts
                                    ? "Select at least one font from the pool to start."
                                    : "Type some text to see the mixed-font result."}
                            </p>
                        </div>
                    ) : (
                        <div className="svg-container svg-container--fill">
                            <svg
                                ref={svgRef}
                                viewBox={viewBox}
                                xmlns="http://www.w3.org/2000/svg"
                                className="font-mixer-svg"
                                style={{ touchAction: "none" }}
                                {...panHandlers}
                            >
                                <g className="font-mixer">
                                    {charLayout.map((c, i) => (
                                        <text
                                            key={i}
                                            x={c.x}
                                            y={c.y}
                                            fontFamily={c.font}
                                            fontWeight={c.weight}
                                            fontSize={c.fontSize}
                                            fill="black"
                                        >
                                            {c.char}
                                        </text>
                                    ))}
                                </g>
                            </svg>
                        </div>
                    )}
                </div>
                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        {charLayout.length > 0
                            ? `${charLayout.length} character${charLayout.length === 1 ? "" : "s"} across ${selectedFonts.length} font${selectedFonts.length === 1 ? "" : "s"}.`
                            : "No characters to display."}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        disabled={!canExport}
                        onClick={handleDownload}
                    >
                        Download result SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
